import state from './Jdproduct/states'
import mutations from './Jdproduct/mutations'
import actions from './Jdproduct/actions'
import getters from './Jdproduct/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
